import React from 'react';
import './index.scss';
import ReactDOM from 'react-dom';
import FadeIn from 'react-fade-in';
import themes from './themes.json'

/* Components */
import Catalog from './Catalog'
import Spotify from './Spotify'
import Notes from './Notes'
import Letterbox from './Letterbox'
import Airplanes from './Airplanes'
import Socials from './Socials'

/* fa icons */
import { 
  FaFolderOpen, 
  FaAngleDoubleLeft,
  FaRegLemon,
  FaRegKissWinkHeart,
  FaEnvelope,
  FaFileDownload,
  FaPaperPlane,
  FaDumbbell
} from 'react-icons/fa';

import {
  BrowserRouter,
  Routes,
  Route,
  Link
} from "react-router-dom";


function atHomepage() {
  if (window.location.pathname === "/") {
    return true
  } else {
    return false
  }
}

// Page background plus the phone browser's address bar / status bar tint.
// Mobile browsers color their toolbars from <meta name="theme-color">,
// so without this the bar stays black while the page changes color.
function applyPageColor(color) {
  document.body.style.backgroundColor = color
  document.documentElement.style.backgroundColor = color
  var meta = document.querySelector('meta[name="theme-color"]')
  if (!meta) {
    meta = document.createElement('meta')
    meta.name = 'theme-color'
    document.head.appendChild(meta)
  }
  meta.content = color
}

Array.prototype.sample = function () {
  return this[Math.floor(Math.random() * this.length)];
}

class App extends React.Component { 
  constructor(props) {
    super(props)
    this.state = { 
      atHome: atHomepage(),
      theme: "blackout",
      spins: 0
    }

    this.randomizeTheme = this.randomizeTheme.bind(this);
  }

  randomizeTheme() {
    var theme = this.state.theme
    while (theme == this.state.theme) { theme = Object.keys(themes).sample() }
    this.setState({ theme: theme, spins: this.state.spins + 1 })
    applyPageColor(themes[theme]["secondary"])
    return theme
  }

  render() {
    return (
      <BrowserRouter>
        <p style={{ display: "none" }} id="currentTheme">{this.state.theme}</p>
        { atHomepage() && <Airplanes color={themes[this.state.theme]["primary"]} /> }
        <button
          type="button"
          id="themeBtn"
          className="theme-icon"
          style={{ color: themes[this.state.theme]["primary"], "--spin": this.state.spins }}
          onClick={this.randomizeTheme}
          aria-label="Change colors"
          title="Change colors"
        >
          <FaRegLemon />
        </button>
        { atHomepage() ?
          <FadeIn>
            <div className="icons">
              {/* FlightPath lives outside the React router — plain <a> forces a full page load to /fp */}
              <a
                className="fa-link"
                style={{ color: themes[this.state.theme]["primary"] }}
                href="/fp/"
                title="FlightPath"
                aria-label="FlightPath"
              >
                <FaPaperPlane />
              </a>
              {/* Daily Reps also lives outside the React router — full page load to /reps */}
              <a
                className="fa-link"
                style={{ color: themes[this.state.theme]["primary"] }}
                href="/reps/"
                title="Daily Reps"
                aria-label="Daily Reps"
              >
                <FaDumbbell />
              </a>
              <Socials
                primary={themes[this.state.theme]["primary"]}
                secondary={themes[this.state.theme]["secondary"]}
                onNavigate={() => this.setState({ atHome: true })}
              />
              <a
                className="fa-link"
                style={{ color: themes[this.state.theme]["primary"] }}
                href="mailto:blake@flyboyblake.com"
                title="Email"
                aria-label="Email blake@flyboyblake.com"
              >
                <FaEnvelope />
              </a>
              <a 
                className="fa-link" 
                style={{ color: themes[this.state.theme]["primary"] }} 
                href="https://www.instagram.com/ashtonchristopherson/" 
                target="_blank"
              >
                <FaRegKissWinkHeart />
              </a>
              <a
                className="fa-link"
                style={{ color: themes[this.state.theme]["primary"] }}
                href="./BlakeResume2026.pdf"
                target="_blank"
              >
                <FaFileDownload />
              </a>
            </div>
          </FadeIn>
          :
          <Link 
            className="fa-link"
            style={{ color: themes[this.state.theme]["primary"] }}
            to="/" 
            onClick={() => this.setState({ atHome: true })}
          >
            <FaAngleDoubleLeft />
          </Link>
        }
        <div className="revision" style={{ color: themes[this.state.theme]["primary"]}}>flyboyblake.com</div>
        <Routes>
          <Route path="/"></Route>
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/discography" element={<Spotify theme={this.state.theme} />} />
          <Route path="/films" element={<Letterbox theme={this.state.theme} />} />
          <Route path="/pdf" element={<Letterbox theme={this.state.theme} />} />
        </Routes>
      </BrowserRouter>
    );
  };
}

// ========================================

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
